import React from 'react';
import PropTypes from 'prop-types';

export default function PageTitle(props) {
    return (
        <header className={`console-page-header ${props.className || ''}`.trim()}>
            <div className="console-page-header__inner">
                {props.children}
            </div>
        </header>
    );
}

PageTitle.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]).isRequired,
    className: PropTypes.string,
};

PageTitle.defaultProps = {
    className: '',
};
